import constantes from '../helpers/constanteHelper'

import { useNavigate } from 'react-router-dom'

import Image from 'react-bootstrap/Image';

function CardEmpresaBEA({ empresa, resolucaoMobile, desativarLink }) {
    const navigate = useNavigate();

    return (
        <div className='animate__animated animate__fadeIn d-flex align-items-center justify-content-center' onClick={desativarLink ? () => {} : () => {navigate(`/catalogo-bea/marcas/${empresa['Slug (Url)']}`)}} style={{ cursor: 'pointer', width: '319px', height: '180px', background: constantes.CORES.BRANCO_PADRAO, borderRadius: '20px' }}>
            <Image style={{height: '180px', objectFit: 'contain', padding: '25px'}} src={empresa['Link da logo da empresa']} alt='logo' fluid /> 
        </div>
    );
}
export default CardEmpresaBEA;
